import { Text } from '@/components/ui/Text';
import { getCurrencySymbol } from '@/lib/currency';
import { useI18n } from '@/locales';

interface SecurityDepositNoteProps {
	currency: string;
	securityDeposit: number;
	className?: string;
}

/** Tells the guest about a refundable deposit the host collects separately. Renders nothing when there is none. */
export const SecurityDepositNote = ({
	currency,
	securityDeposit,
	className,
}: SecurityDepositNoteProps) => {
	const t = useI18n();
	if (!securityDeposit) return null;
	return (
		<Text variant="bodySmall" className={className}>
			{t('SecurityDeposit.title', {
				symbol: getCurrencySymbol(currency),
				securityDeposit,
			})}
		</Text>
	);
};
